import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://backend.planit.pk";

if (!process.env.REACT_APP_SOCKET_URL) {
    console.warn("⚠️ REACT_APP_SOCKET_URL is not defined in .env. Defaulting to:", SOCKET_URL);
}

class SocketService {
    socket = null;
    // Listeners registered before connect() — replayed once socket is created
    _pending = [];

    connect() {
        if (this.socket) return;

        this.socket = io(SOCKET_URL, {
            transports: ["websocket", "polling"],
            reconnection: true,
        });

        // Replay every listener that was registered before the socket existed
        this._pending.forEach(({ event, cb }) => this.socket.on(event, cb));
        this._pending = [];

        this.socket.on("connect", () => {
            console.log("✅ Socket connected:", this.socket.id);
        });

        this.socket.on("connect_error", (err) => {
            console.error("❌ Socket connection error:", err.message);
        });

        this.socket.on("disconnect", (reason) => {
            console.log("⚠️ Socket disconnected:", reason);
        });
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
        this._pending = [];
    }

    on(eventName, callback) {
        if (this.socket) {
            this.socket.on(eventName, callback);
        } else {
            // Queue it — will be replayed once connect() is called
            this._pending.push({ event: eventName, cb: callback });
        }
    }

    off(eventName, callback) {
        if (this.socket) {
            this.socket.off(eventName, callback);
        } else {
            // Remove from the pending queue so cleanup works correctly
            this._pending = this._pending.filter(
                l => !(l.event === eventName && l.cb === callback)
            );
        }
    }

    emit(eventName, data) {
        if (this.socket) {
            this.socket.emit(eventName, data);
        }
    }

    isConnected() {
        return this.socket?.connected === true;
    }
}

const socketServiceInstance = new SocketService();
export default socketServiceInstance;
